import { VStack } from '@chakra-ui/react'
import { PaymentHeader, PageBackLink, PaymentMethodList } from '@!/User/Payment/components'

export const PaymentSelect = ({ pageBack, creditCardLink, handlePurchase }) => {
  return (
    <VStack maxW="600px" m="auto" gap={6}>
      <PaymentHeader />
      <PaymentMethodList creditCardLink={creditCardLink} handlePurchase={handlePurchase} />
      <PageBackLink pageBack={pageBack} />
    </VStack>
  )
}
